module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "time"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "hintText": "选择日期",
      "label": this.label,
      "mode": "landscape",
      "autoOk": true,
      "errorText": _vm.errorText
    },
    on: {
      "change": _vm.inputHandler
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a302f3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/datePickerEl.vue
// module id = 1010
// module chunks = 2